import React, {memo, useEffect, useState} from "react";
import Api from '../../interface/api/host';
import {BlueButton} from "../../component/button";
import {HostInfo} from '../../interface/model/host';

interface FindHost {
    modal:boolean,
    hostName:string
}

interface FindHostModalProps {
    findHostData:FindHost,
    closeModalHandler: () => void,
    onClickHandler: (hostInfo: HostInfo) => HostInfo
}

interface FoundHostData {
    mode:boolean,
    hostInfo?:HostInfo
}
function FindHostComponent({onClickHandler}) {

    const [ foundHostData, setFoundHostData ] = useState<FoundHostData>({mode : false});
    const [ findHostData, setFindHostData ] = useState<FindHost>({modal:false, hostName:''});

    function findHostSubmitHandler(e) {
        e.preventDefault();
        if(findHostData.hostName.replace(/ /gi,"").length < 2) {
            alert('검색할 이름을 정확히 입력해주세요.');
        } else {
            setFindHostData({...findHostData, modal:true})
        }
    }

    function selectedHostHandler(hostInfo:HostInfo) {
        setFoundHostData({mode:true, hostInfo:hostInfo});
        onClickHandler(hostInfo);
    }

    function closeModalHandler() {
        setFindHostData({modal:false, hostName:''})
    }

    return (
        <form onSubmit={findHostSubmitHandler}>
            <div className="search_box">
                {
                    foundHostData.mode
                        ?   <>
                                {/*<p style={{padding: '4px'}}>{`[${foundHostData.hostInfo.team}] ${foundHostData.hostInfo.name}님`}</p>*/}
                                <input  type="text"
                                    className="nv_input"
                                    name="host_name"
                                    readOnly={true} disabled={true}
                                    value={`[${foundHostData.hostInfo.team}] ${foundHostData.hostInfo.name}님`}
                                    />
                                <BlueButton
                                    type={'button'}
                                    onClickHandler={() => setFoundHostData({mode:false})}
                                    innerHTML={'변경'}/>
                        </>
                        :   <>
                                <input  type="text"
                                        className="nv_input"
                                        name="host_name"
                                        placeholder="이름을 입력해주세요"
                                        onChange={(e) => setFindHostData({...findHostData, hostName : e.target.value})}
                                        value={findHostData.hostName}
                                        required/>
                                <BlueButton
                                    type={'submit'}
                                    onClickHandler={null}
                                    innerHTML={'검색'}/>
                            </>
                }
            </div>
            {
                findHostData.modal &&
                    <Modal
                        findHostData={findHostData}
                        closeModalHandler={closeModalHandler}
                        onClickHandler={selectedHostHandler}/>
            }
        </form>
    )
}

export default memo(FindHostComponent);

function Modal({findHostData, closeModalHandler, onClickHandler}) {

    const [ hosts, setHosts ] = useState<Array<HostInfo>>([]);

    function clickHost(row) {
        onClickHandler(row);
        closeModalHandler();
    }

    useEffect(() => {
        let siteInfo = null;
        try {
            siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
        } catch (err) {}
        if(siteInfo === null)
            alert('초기화면에서 사업장 선택을 해주세요.');

        Api.hostInfoListByHostName(findHostData.hostName).then(res => {
            setHosts(res.data);
        });

    }, [findHostData.hostName]);

    return (
        <div className="nv_modal nv_modal1 on">
            <div className="nv_modal_container">
                <div className="nv_modal_header">
                    <h2 id="find-host-title">접견인 선택</h2>
                    <p className="nv_modal_close" onClick={closeModalHandler}>닫기</p>
                </div>
                <div className="nv_modal_contents">
                    <table className="nv_table textcenter" id="host_name_search_table">
                        <colgroup>
                            <col width={'20%'}/>
                            <col width={'30%'}/>
                            <col width={'30%'}/>
                            <col width={'20%'}/>
                        </colgroup>
                        <thead>
                        <tr>
                            <th scope="row">이름</th>
                            <th scope="row">팀</th>
                            <th scope="row">사업장</th>
                            <th scope="row">선택</th>
                        </tr>
                        </thead>
                        <tbody id="host_table_tbody">
                        {
                            hosts.length === 0
                                ?   <tr>
                                        <td colSpan={3}>조회결과가 없습니다.</td>
                                    </tr>
                                :   hosts.map((row, index) => (
                                    <tr key={`findHostKey-${index}`}>
                                        <td>{row.name}</td>
                                        <td>{row.team}</td>
                                        <td>{row.siteInfo.parentSiteInfo.name}-{row.siteInfo.name}</td>
                                        <td>
                                            <BlueButton
                                                type={'button'}
                                                onClickHandler={() => clickHost(row)}
                                                innerHTML={'확인'}/>
                                        </td>
                                    </tr>
                                ))
                        }
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                </div>
            </div>
        </div>
    )
}